import { Component,Input, OnInit } from '@angular/core';
import { ProfileModel } from 'src/app/models/profile.model';
import { ExternalService } from 'src/app/services/external/external.service';

@Component({
  selector: 'contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
})
export class ContactDetailsComponent implements OnInit {

  @Input()
  title:string;

  @Input()
  displayAddress:boolean;

  @Input() 
  profile:ProfileModel;

  constructor(public externalService:ExternalService) {
  }

  ngOnInit(){
  }

}
